import React from "react";
import { Card, Box, Typography } from "@mui/material";

const CircleRateCard = ({
  circle_rate_appl,
  circle_rate,
}: {
  circle_rate_appl?: number | string | null;
  circle_rate?: number | string | null;
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1.5px solid #3A1C73",
        borderRadius: "10px",
        backgroundColor: "#FFF6E8",
        padding: "16px 18px",
        width: "100%",
        mb: 2,
      }}
    >
      <Typography fontSize={16} fontWeight={600} color="#212121" mb={0.5}>
        Circle Rate (in sq. m)
      </Typography>

      <Typography fontSize={14} color="#F57C00" mb={1.5}>
        Circle rate has been reviewed and updated by the Authority after
        verifying the applicant’s details and identifying discrepancies.
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        {circle_rate && circle_rate_appl && circle_rate !== circle_rate_appl ? (
          <>
            <Typography
              fontSize={14}
              sx={{
                textDecoration: "line-through",
                color: "#9E9E9E",
              }}
            >
              Rs {circle_rate_appl ? circle_rate_appl : "0"}
            </Typography>

            <Typography fontSize={18} fontWeight={700} color="#212121">
              Rs {circle_rate ? circle_rate : "0"}
            </Typography>
          </>
        ) : (
          <Typography fontSize={18} fontWeight={700} color="#212121">
            Rs {circle_rate || circle_rate_appl || "0"}
          </Typography>
        )}

        <Typography fontSize={14} color="#9E9E9E">
          (per square meter)
        </Typography>
      </Box>
    </Card>
  );
};

export default CircleRateCard;
